<template>
  <BaseFullScreen :class="$style.screen">
    <BaseMask />
    <div :class="$style.inner"><slot /></div>
  </BaseFullScreen>
</template>
<script>
import BaseFullScreen from '@/common/BaseFullScreen'
import BaseMask from '@/common/BaseMask'

export default {
  components: {
    BaseMask,
    BaseFullScreen
  }
}
</script>
<style  module lang="postcss">
.screen {
  z-index: 3;
}

.inner {
  position: absolute;
  top: 0;
  left: 50%;
  box-sizing: border-box;
  min-width: 180px;
  padding: 16px;
  margin: 150px auto 0;
  border-radius: 4px;
  line-height: 22px;
  text-align: center;
  color: rgba(255, 255, 255, .8);
  transform: translateX(-50%);
}

</style>



// WEBPACK FOOTER //
// src/components/Alert/AlertInnerTransparent.vue